export default __webpack_public_path__ + "static/media/1974.e172c611.png";